import { ajaxPostJson } from './ajax';
// 源语言与目标语言
export const queryLanguageList= (params) => {
  return ajaxPostJson(`/common/queryLangList`, params);
};
// 根据语言获取相关领域
export const queryTransDomain= (params) => {
  // params.dataType = 'trans_domain';
  return ajaxPostJson(`/common/queryTransDomain`, params);
};
// 创建作业
export const createStudentJob= (params) => {
  return ajaxPostJson(`/project/save`, params);
};
// 根据id查询文件信息
export const getFileInfo= (params) => {
  return ajaxPostJson(`/project/queryFile`, params);
};
// 查询所有领域
export const queryDomainList= (params) => {
  return ajaxPostJson(`/project/queryDomainList`, params);
};
//自动检测语言
export const language= (params) => {
  return ajaxPostJson(`/file/language`, params);
};
